/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import og from './asset/og.png';
import eye from './asset/eye.png';
import head from './asset/head.png';
import body from './asset/body.png';
import arm from './asset/arm.png';
import background from './asset/bg.png';
import styled, { keyframes } from 'styled-components'
import Snowfall from 'react-snowfall'
import './App.css';

class RadioButton extends React.Component {
  render() {
    const { name, value, currentValue, onChange } = this.props;
    
    return (
      <label className={value === currentValue ? 'label active' : 'label'}>
        <input
          name={name}
          value={value}
          type="radio"
          onChange={onChange}
          hidden
          />{value}
      </label>
    );
  }
}

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      speed: 2,
      value: 'Animated',
      animated: true,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (e) => {
    this.setState(prevState => ({
      animated: !prevState.animated,
      value: e.target.value 
    }));
  };

  render() {
    const animSpeed = this.state.speed

    const eyeAnimation = keyframes`
      0% { filter: brightness(0.5); transform: translateY(0) }
      2% { filter: brightness(0.5); transform: translateY(0) }
      49% { filter: brightness(2); transform: translateY(-1%) }
      51% { filter: brightness(2); transform: translateY(-1%) }
      98% { filter: brightness(0.5); transform: translateY(0) }
      100% { filter: brightness(0.5); transform: translateY(0) }
    `

    const headAnimation = keyframes`
      0% { transform: translateY(0) }
      2% { transform: translateY(0) }
      49% { transform: translateY(-1%) }
      51% { transform: translateY(-1%) }
      98% { transform: translateY(0) }
      100% { transform: translateY(0) }
    `
    const bodyAnimation = keyframes`
      0% { transform: scale(1) }
      2% { transform: scale(1) }
      49% { transform: scale(1.03)}
      51% { transform: scale(1.03)}
      98% { transform: scale(1) }
      100% { transform: scale(1) }
    `

    const armAnimation = keyframes`
      0% { transform: translateY(0) scale(1) }
      2% { transform: translateY(0) scale(1) }
      49% { transform: translateY(-1%) scale(1.02) }
      51% { transform: translateY(-1%) scale(1.02) }
      98% { transform: translateY(0) scale(1) }
      100% { transform: translateY(0) scale(1) }
    `

    const Eye = styled.div`
      position: absolute;
      height: 100%;
      width: 100%;
      animation: ${eyeAnimation} ${animSpeed * 2}s infinite cubic-bezier(.17,.67,.83,.67);
    `
    
    const Head = styled.div`
      position: absolute;
      height: 100%;
      width: 100%;
      animation: ${headAnimation} ${animSpeed * 2}s infinite cubic-bezier(.17,.67,.83,.67);
    `
    
    const Body = styled.div`
      position: absolute;
      height: 100%;
      width: 100%;
      transform-origin: bottom;
      animation: ${bodyAnimation} ${animSpeed * 2}s infinite cubic-bezier(.17,.67,.83,.67);
    `

    const Arm = styled.div`
      position: absolute;
      height: 100%;
      width: 100%;
      animation: ${armAnimation} ${animSpeed * 2}s infinite cubic-bezier(.17,.67,.83,.67);
    `

    return (
      <div className="App">
        <div className="toggle" onChange={this.onChangeValue}>
          <RadioButton
            name="type"
            value="Animated"
            currentValue={this.state.value}
            onChange={this.handleChange}
          />
          <RadioButton
            name="type"
            value="Static"
            currentValue={this.state.value}
            onChange={this.handleChange}
          />
        </div>

        <div className="static">
          <img src={og} className="og" />
        </div>

        <div className={this.state.animated ? 'anim visible' : 'anim invisible'}>
          <img src={background} className="background" />
          <Snowfall 
            snowflakeCount={20}
          />
          <Arm><img src={arm} className="arm" /></Arm>
          <Body><img src={body} className="body" /></Body>
          <Head><img src={head} className="head" /></Head>
          <Eye><img src={eye} className="eye" /></Eye>
          <Snowfall 
            snowflakeCount={5}
          />
        </div>

        <div className="credit">
          Image Credit: <a href="https://www.telegraph.co.uk/tv/2019/05/14/killing-night-king-stupidest-thing-game-thrones-has-ever-done/" rel="noreferrer" target="_blank">The Telegraph</a>
        </div>
      </div>
    );
  }
}

export default App;
